import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconEdgeRight12 from './IconEdgeRight12';
import IconEdgeRight16 from './IconEdgeRight16';
import IconEdgeRight20 from './IconEdgeRight20';
import IconEdgeRight24 from './IconEdgeRight24';
import IconEdgeRight32 from './IconEdgeRight32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconEdgeRight = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconEdgeRight12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconEdgeRight16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconEdgeRight20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconEdgeRight24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconEdgeRight32 {...props} />}
        </span>
    );
};
IconEdgeRight.displayName = 'FondueIconEdgeRight';

export default memo(IconEdgeRight);
